import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import StyledCard from "components/UI/StyledCard";
import COLORS from 'lib/colors'


export function FormPostingSetup({url}) {

  return (
    <StyledCard
      title='Form Posting Setup'
      note='Send your leads via HTTP POST to the following endpoint. Request body must be JSON with given headers.'
      isSubsection={true}
    >
      <Stack direction='column' gap={3} divider={<Divider light flexItem />} sx={{ p: '18px 24px 24px 24px' }}>
        <TextField
          value={url}
          label='HTTP Post'
          fullWidth
          disabled
        />
          <Table
            sx={{
              '.MuiTableRow-root': { display: 'grid', gridTemplateColumns: '1fr 3fr', columnGap: 4 },
              '.MuiTableHead-root .MuiTableCell-root': { p: 0, color: COLORS.slateGray },
              '.MuiTableCell-root': { border: 'none', p:0, pb: .5, pt: 2, color: COLORS.charcoal, fontWeight: 600 },
            }}>
            <TableHead>
              <TableRow>
                <TableCell>Header</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell><code>Content-type</code></TableCell>
                <TableCell><code>application/json</code></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>X-Api-Key</code></TableCell>
                <TableCell>Your API key</TableCell>
              </TableRow>
            </TableBody>
          </Table>
      </Stack>
    </StyledCard>
  )
}
